// StudentHints.jsx
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectStudentAccessToken } from "../../redux/authStudent/selector.js";
import { useTranslation } from "react-i18next";
import styles from "./StudentHints.module.css"; // создадим позже

const StudentHints = () => {
  const studentToken = useSelector(selectStudentAccessToken);
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const lang = i18n.language || "en";
const titleRef = useRef(null);
  useEffect(() => {
    if (!studentToken) return;

    const dismissed = localStorage.getItem("studentHintsDismissed");
    if (dismissed === "true") return;

    const postponedUntil = localStorage.getItem("studentHintsPostponed");
    if (postponedUntil) {
      const now = new Date();
      const postponedDate = new Date(postponedUntil);
      if (now >= postponedDate) setVisible(true);
    } else {
      setVisible(true);
    }
  }, [studentToken]);

  const handleDismiss = () => {
    localStorage.setItem("studentHintsDismissed", "true");
    setVisible(false);
  };

  const handlePostpone = () => {
    const date = new Date();
    date.setDate(date.getDate() + 3);
    localStorage.setItem("studentHintsPostponed", date.toISOString());
    setVisible(false);
  };
useEffect(() => {
  if (visible && titleRef.current) {
    titleRef.current.focus();
  }
}, [visible]);
  if (!visible) return null;

  return (
    <div
      className={styles.hintsContainer}
      role="region"
      aria-label={t("studentHints.ariaLabel")}
    >
      <h3 tabIndex={-1} className={styles.title} ref={titleRef}>
        {t("studentHints.title")}
      </h3>
      <ul className={styles.hintList}>
        <li>
          <button
            className={styles.hintItem}
            onClick={() => navigate(`/${lang}/students-profile`)}
          >
            👤 <b>{t("studentHints.profileTitle")}</b> —{" "}
            {t("studentHints.profileText")}
          </button>
        </li>
        <li>
          <button
            className={styles.hintItem}
            onClick={() => navigate(`/${lang}/teachers?page=1&limit=12`)}
          >
            🔍 <b>{t("studentHints.searchTitle")}</b> —{" "}
            {t("studentHints.searchText")}
          </button>
        </li>
        <li>
          <button
            className={styles.hintItem}
            onClick={() => navigate(`/${lang}/available-slots?page=1&limit=6`)}
          >
            🗓️ <b>{t("studentHints.bookTitle")}</b> —{" "}
            {t("studentHints.bookText")}
          </button>
        </li>
        <li>
          <button className={styles.chat}>
            💬 <b>{t("studentHints.messageTitle")}</b> —{" "}
            {t("studentHints.messageText")}
          </button>
        </li>
        <li>
          <button className={styles.video}>
            📹 <b>{t("studentHints.joinTitle")}</b> —{" "}
            {t("studentHints.joinText")}
          </button>
        </li>
        <li>
          <button
            className={styles.hintItem}
            onClick={() => navigate(`/${lang}/benefits`)}
          >
            ⭐ <b>{t("studentHints.benefitsTitle")}</b> —{" "}
            {t("studentHints.benefitsText")}
          </button>
        </li>
      </ul>
      <div className={styles.buttons}>
        <button onClick={handlePostpone}>{t("studentHints.postpone")}</button>
        <button onClick={handleDismiss}>{t("studentHints.dismiss")}</button>
      </div>
    </div>
  );
};

export default StudentHints;
